export interface IMapViewPallette {
    editedGeometryColor: string | null;
    editedGeometryFillColor: string | null;

    geometryColor: string | null;
    geometryOutlinePattern: string | null;
    geometryFillColor: string | null;

    rulerColor: string | null;
    rulerFillColor: string | null;
}

export const GeometryOutlinePatterns = {
    DASHED: "dashed",
    DOTTED: "dotted",
    SOLID: "solid",
} as const;
export type GeometryOutlinePattern = typeof GeometryOutlinePatterns[keyof typeof GeometryOutlinePatterns];
